import { render } from "./BusinessPartnerList.vue?vue&type=template&id=415ffa52"
import script from "./BusinessPartnerList.vue?vue&type=script&lang=js"
export * from "./BusinessPartnerList.vue?vue&type=script&lang=js"

import exportComponent from "D:\\过去云盘内容\\前端代码\\前端项目\\rdsv3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__